import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoLu: CultureInfo = {
  name: 'lu',
  displayName: 'Tshiluba',
  iso3LanguageCode: 'lub',
  iso2LanguageCode: 'lu',
  ietfLanguageTag: 'lu',
  parent: null
};
